import Cookies from 'js-cookie';
import {getFileType} from "../../utils/helpers";
import gsap from "gsap";
import { apiCall } from "../narrativeUtils/fetch";
import Config from "../../Config.json";

function UploadFile(
    org_id,
    username,
    files,
    validations,
    fetchJSON,
    setShowLoader,
    setNewFileId,
    setFormError,
    activeCategory
    ){
    
    var formData = new FormData();
    let newError;
    let fileFormat;
    let formHeaders;
    let fileField = 'file_original';
    var arrayLength = files.length;

    for (var i = 0; i < arrayLength; i++) {

        formHeaders = {
            'Content-Disposition': 'attachment; filename=' + files[i].name,
            'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
        }
        // let fileType = getFileType(files[i].name);
        // File Checks
        let sizeMB = parseFloat(files[i].size / (1024 ** 2)).toFixed(2);
        if (sizeMB > validations.maxFileSize) {
            newError = {
                "heading": "Error",
                "text": "The selected file is <strong>" + sizeMB + "MB</strong>.<br/>This file exceeds maximum upload size of <strong>10MB</strong>.<br/><br/>Please select a new file that is less than 10MB."
            };

        } else {
            formData.append(fileField, files[i], files[i].name) 
            formData.append('new', true)
            if (activeCategory) {
                formData.append('folder', activeCategory)
            }
            
            if (org_id) {
                formData.append('org', org_id);
            }
            console.log('newFile obj', files[i], files[i].name)
            // formData.append('username', username);
        } 

    }

    for (var pair of formData.entries()) { console.log(pair[0]+ ', ' + pair[1]); }

    let fileInput = document.getElementById('uploadLibraryAsset');
    fileInput.files = null;
    fileInput.value = "";

    // console.log('formData', formData, formHeaders)

    if (!newError) {

    setShowLoader(true);
    let api_url = Config.baseURLcms + 'asset-library/';

    function responseTask(response){
        console.log('UploadFile response', response);
       

        setTimeout(() => {
            function callback() {
                setNewFileId(response.data['id'])
            }
            fetchJSON(callback());
        }, 2000);
    }
    apiCall("POST", api_url, formData, responseTask, formHeaders, setFormError, setShowLoader)

    
    } else {
        setFormError(newError);
    }


}

export { UploadFile }